import React, { createContext, useContext } from 'react';
import { useAuth } from '../context/AuthContext';

const PermissionsContext = createContext(null);

export const usePermissions = () => {
  const context = useContext(PermissionsContext);
  if (!context) {
    throw new Error('usePermissions doit être utilisé à l\'intérieur d\'un PermissionsProvider');
  }
  return context;
};

export const PermissionsProvider = ({ children }) => {
  const { currentUser } = useAuth();

  const hasPermission = (permission) => {
    if (!currentUser) return false;
    
    // Le SuperAdmin a toutes les permissions
    if (currentUser.role === 'SUPER_ADMIN') return true;

    // Vérifier les permissions personnalisées si elles existent
    if (currentUser.customPermissions?.includes(permission)) return true;

    // Vérifier les permissions basées sur le rôle
    const rolePermissions = {
      ADMIN: [
        'users:view',
        'absences:view', 'absences:create', 'absences:edit', 'absences:delete',
        'astreintes:view', 'astreintes:create', 'astreintes:edit', 'astreintes:delete'
      ],
      VIEWER: [
        'absences:view',
        'astreintes:view'
      ]
    };

    return rolePermissions[currentUser.role]?.includes(permission) || false;
  };

  return (
    <PermissionsContext.Provider value={{ hasPermission }}>
      {children}
    </PermissionsContext.Provider>
  );
};

export default PermissionsContext; 